export default __webpack_public_path__ + "static/media/staff8.db6eb559.jpg";